import type { Language } from "../domain/quote";

const LOCALE: Record<Language, string> = { es: "es-MX", en: "en-US" };

/** Formats cents as money in the quote's language. Falls back gracefully for unknown codes. */
export function formatMoney(cents: number, currency: string, language: Language = "es"): string {
  try {
    return new Intl.NumberFormat(LOCALE[language], { style: "currency", currency }).format(
      cents / 100,
    );
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

/** Formats an ISO date (YYYY-MM-DD) or timestamp as a long, unambiguous date. */
export function formatLongDate(iso: string, language: Language = "es"): string {
  const date = iso.length === 10 ? new Date(`${iso}T12:00:00Z`) : new Date(iso);
  return new Intl.DateTimeFormat(LOCALE[language], { dateStyle: "long", timeZone: "America/Monterrey" }).format(date);
}

export function formatQuantity(quantity: number, language: Language = "es"): string {
  return new Intl.NumberFormat(LOCALE[language], { maximumFractionDigits: 2 }).format(quantity);
}

/** Splits free text into paragraphs (blank-line separated). Line breaks inside a paragraph are kept. */
export function paragraphs(text: string): string[] {
  return text
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
}
